// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_HTf","cls2":"SuggestionCard-cls2_6HB SuggestionCard-cls1_HTf"};